export class SurveyConfiguration{
  principal_color = '#0E1C2C';
}
